import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import defaultProfilePicture from '../../../../assets/images/blob-avatar.png';
import { hapticsImpactLight } from '../../../../utils/haptics';
import type { RootState } from '../../../../store/store';

interface UserAvatarButtonProps {
  className?: string;
}

/**
 * The student's profile picture (the default blob when they have none) with
 * its soft glow, linking to the account page. Shared by the AI desktop's
 * greeting and the Dashboard header.
 */
const UserAvatarButton = ({ className }: UserAvatarButtonProps) => {
  const navigate = useNavigate();

  const profilePictureUrl = useSelector(
    (state: RootState) => state.user.profile?.profilePictureUrl
  );

  const name = useSelector((state: RootState) => state.user.profile?.name);

  const avatarSrc = useMemo(
    () => profilePictureUrl || defaultProfilePicture,
    [profilePictureUrl]
  );

  return (
    <button
      aria-label="Navigate to account"
      className={['user-avatar-button', className].filter(Boolean).join(' ')}
      onClick={() => {
        navigate('/account');
        hapticsImpactLight();
      }}
      type="button"
    >
      <img
        className="user-avatar-button__image"
        src={avatarSrc}
        alt={name || 'Profile picture'}
      />
      <img
        className="user-avatar-button__glow"
        src={avatarSrc}
        alt=""
        aria-hidden="true"
      />
    </button>
  );
};

export default UserAvatarButton;
